import EvidenceFigure from './EvidenceFigure';
import { urlImpactOf, urlImpactValue } from './urlImpact';

type UrlImpactFigureProps = {
  name: string;
  affectedUrlCount: number;
  crawledUrlCount: number;
  note?: string;
};

function UrlImpactFigure({ name, affectedUrlCount, crawledUrlCount, note }: UrlImpactFigureProps) {
  const impact = urlImpactOf(affectedUrlCount, crawledUrlCount);

  return (
    <EvidenceFigure
      name={name}
      help={[impact.share === null ? [] : [`${impact.share} of the URLs crawlers requested`], note ?? []].flat()}
      className="diagnostics-evidence-figure-apart"
    >
      {urlImpactValue(impact)}
    </EvidenceFigure>
  );
}

export default UrlImpactFigure;
